import axios from "axios";

const API = axios.create({baseURL: "https://supertweet-backend-api.onrender.com"})

export const uploadPost = (data) => API.post('/posts', data)